window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.frame-type-booking_finalexam').length) {
    import('./_perform-final-exam.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
